import React, { useState } from 'react';
import profile from '../data/profile';

const Projects = () => {
  const [activeFilter, setActiveFilter] = useState('all');

  const projects = profile.projects;

  const filters = [
    { id: 'all', label: 'Tous' },
    { id: 'web', label: 'Web' },
    { id: 'mobile', label: 'Mobile' },
    { id: 'backend', label: 'Backend' }
  ];

  const filteredProjects = activeFilter === 'all' 
    ? projects 
    : projects.filter(project => project.category === activeFilter);

  return (
    <section id="projects" className="py-16 sm:py-20 bg-slate-800">
      <div className="container mx-auto px-4 sm:px-6">
        {/* Header */}
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4 sm:mb-6">
            Mes <span className="text-gradient">projets</span>
          </h2>
          <p className="text-base sm:text-lg lg:text-xl text-gray-300 max-w-3xl mx-auto">
            Découvrez une sélection de mes réalisations qui démontrent mon expertise 
            et ma passion pour le développement web.
          </p>
        </div>

        {/* Filters */}
        <div className="flex flex-wrap justify-center gap-2 sm:gap-4 mb-8 sm:mb-12">
          {filters.map((filter) => (
            <button
              key={filter.id}
              onClick={() => setActiveFilter(filter.id)}
              className={`px-4 sm:px-6 py-2 sm:py-3 rounded-full font-semibold transition-all duration-200 text-sm sm:text-base ${
                activeFilter === filter.id
                  ? 'bg-gradient-primary text-white shadow-lg'
                  : 'bg-slate-600 text-gray-300 hover:bg-slate-500 hover:text-white'
              }`}
            >
              {filter.label}
            </button>
          ))}
        </div>

        {/* Projects Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {filteredProjects.map((project) => (
            <div 
              key={project.id}
              className="group bg-slate-700 rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300 transform hover:scale-105"
            >
              {/* Project Image */}
              <div className="relative overflow-hidden">
                <img 
                  src={project.image} 
                  alt={project.title}
                  className="w-full h-40 sm:h-48 object-cover group-hover:scale-110 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                
                {/* Overlay Actions */}
                <div className="absolute inset-0 flex items-center justify-center space-x-2 sm:space-x-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <a 
                    href={project.link}
                    className="bg-white text-primary-600 px-3 sm:px-4 py-1.5 sm:py-2 rounded-full font-semibold hover:bg-primary-50 transition-colors duration-200 text-xs sm:text-sm"
                  >
                    Voir le projet
                  </a>
                  <a 
                    href={project.github}
                    className="bg-primary-600 text-white px-3 sm:px-4 py-1.5 sm:py-2 rounded-full font-semibold hover:bg-primary-700 transition-colors duration-200 text-xs sm:text-sm"
                  >
                    Code source
                  </a>
                </div>
              </div>

              {/* Project Content */}
              <div className="p-4 sm:p-6">
                <h3 className="text-lg sm:text-xl font-bold text-white mb-2 sm:mb-3 group-hover:text-primary-400 transition-colors duration-200">
                  {project.title}
                </h3>
                <p className="text-gray-300 mb-3 sm:mb-4 leading-relaxed text-sm sm:text-base">
                  {project.description}
                </p>
                
                {/* Technologies */}
                <div className="flex flex-wrap gap-1.5 sm:gap-2">
                  {project.technologies.map((tech, index) => (
                    <span 
                      key={index}
                      className="px-2 sm:px-3 py-1 bg-primary-900 text-primary-300 text-xs sm:text-sm font-medium rounded-full"
                    >
                      {tech}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Call to Action */}
        <div className="text-center mt-12 sm:mt-16">
          <div className="bg-gradient-primary rounded-2xl p-6 sm:p-8 text-white">
            <h3 className="text-xl sm:text-2xl font-bold mb-3 sm:mb-4">Intéressé par mon travail ?</h3>
            <p className="text-base sm:text-lg mb-4 sm:mb-6 opacity-90">
              N'hésitez pas à me contacter pour discuter de votre projet
            </p>
            <button className="bg-white text-primary-600 px-6 sm:px-8 py-2.5 sm:py-3 rounded-full font-semibold hover:bg-gray-100 transition-colors duration-200 text-sm sm:text-base">
              Démarrer un projet
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Projects;
